module.exports = __webpack_public_path__ + "static/media/gift_card.70f593f3.svg";